'use client';
import GameListPage from './GameListPage';
import FirstRow from './GameListPage/FirstRow';
import GameListPlaceholder from './GameListPlaceholder';
import useGameListHook from './hooks/useGameListHook';
import Lazy from '../../LazyLoad/Lazy';

const GameList: FC<GameListProps> = (props) => {
  const {
    pageTitle,
    pageSubTitle,
    pageSection,
    hasFilters,
    cmsHandle,
    isLiveRtp,
    width,
    height,
    isGridVisible,
    providerName,
    handleGridVisibleToggle,
  } = useGameListHook(props);
  const placeholder = (
    <GameListPlaceholder
      width={width}
      height={height}
      isGridVisible={isGridVisible}
    />
  );
  return (
    <div className="grid grid-cols-minmax gap-4">
      <FirstRow
        pageTitle={pageSection === 'providers' ? providerName : pageTitle}
        pageSubTitle={pageSubTitle}
        pageSection={pageSection}
        providerName={providerName}
        isGridVisible={isGridVisible}
        onShowGridClick={handleGridVisibleToggle}
        isLiveRtp={isLiveRtp}
        menuItem={props.menuItem}
        theme={props.theme}
        hasFilters={hasFilters}
        isBombayclubGamesPage={props.isBombayclubGamesPage}
      />
      <Lazy placeholder={placeholder}>
        <div className="grid grid-cols-minmax gap-4">
          <GameListPage
            isLiveRtp={isLiveRtp}
            pageSection={pageSection}
            pageTitle={pageTitle}
            isGridVisible={isGridVisible}
            menuItem={props.menuItem}
            theme={props.theme}
            width={width}
            cmsHandle={cmsHandle}
            placeholder={placeholder}
            isRecommendedGames={props.isRecommendedGames}
            isMinMaxBetVisible={props.isBombayclubGamesPage}
            isBreadcrumbsVisible={props.isBombayclubGamesPage}
            page={props.page ?? 1}
          />
        </div>
      </Lazy>
    </div>
  );
};

export default GameList;
